import {
    SCREEN_WIDTH,
    SCREEN_HEIGHT,
} from './GameConst';

export const BATTLE_BOARD_POS = { // カードを置けるマス8つの座標定義
    0: {
        x: SCREEN_WIDTH * 0.26,
        y: SCREEN_HEIGHT * 0.37,
        angle:134,
    },
    1: {
        x: SCREEN_WIDTH * 0.5,
        y: SCREEN_HEIGHT * 0.4,
        angle:180,
    },
    2: {
        x: SCREEN_WIDTH * 0.74,
        y: SCREEN_HEIGHT * 0.37,
        angle:226,
    },
    3: {
        x: SCREEN_WIDTH * 0.32,
        y: SCREEN_HEIGHT * 0.5,
        angle:90,
    },
    4: {
        x: SCREEN_WIDTH * 0.68,
        y: SCREEN_HEIGHT * 0.5,
        angle:270,
    },
    5: {
        x: SCREEN_WIDTH * 0.26,
        y: SCREEN_HEIGHT * 0.63,
        angle:46,
    },
    6: {
        x: SCREEN_WIDTH * 0.5,
        y: SCREEN_HEIGHT * 0.6,
        angle:0,
    },
    7: {
        x: SCREEN_WIDTH * 0.74,
        y: SCREEN_HEIGHT * 0.63,
        angle:314,
    },
};

export const BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION = { // バトルポイントから見た依存ボードのインデックス
    0: {0:4, 1:2},
    1: {1:3, 2:1},
    2: {0:1, 3:3},
    3: {2:4, 4:2},
    4: {3:2, 5:4},
    5: {4:3, 7:1},
    6: {5:1, 6:3},
    7: {6:2, 7:4},
    8: {0:0, 1:1, 3:4},
    9: {1:4, 2:0, 4:1},
    10: {3:1, 5:0, 6:4},
    11: {4:4, 6:1, 7:0},
};

const boardToPoint = {0:[], 1:[], 2:[], 3:[], 4:[], 5:[], 6:[], 7:[]};
for(let boardIndex = 0; boardIndex <= 7; boardIndex++)
{
    for(let pointIndex = 0; pointIndex <= 11; pointIndex++)
    {
        if(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex][boardIndex] != undefined)
        {
            boardToPoint[boardIndex].push(pointIndex);
        }
    }
}

export const BATTLE_BOARD_TO_POINT_RELATION = boardToPoint;

export const BATTLE_POINT_TO_SHURIKEN_EDGE = { // バトルポイントに該当する手裏剣の先端ポイント
    8: 3,
    9: 0,
    10: 2,
    11: 1,
};
